module.exports = __webpack_public_path__ + "img/dovid.e9a017e2.png";